import { ProductCategory } from "modules/products";

const ProductCategoryPage = () => {
  return <ProductCategory />;
};

export default ProductCategoryPage;
